export const GET_SERVICES = 'GET_SERVICES';
export const GET_SERVICES_SUCCEEDED = 'GET_SERVICES_SUCCEEDED';

export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST';
export const GET_PRODUCT_LIST_SUCCEEDED= 'GET_PRODUCT_LIST_SUCCEEDED';
export const GET_PRODUCT_LIST_FAILED = 'GET_PRODUCT_LIST_FAILED';

export const GET_AVAILABLE_TIME = 'GET_AVAILABLE_TIME';
export const GET_AVAILABLE_TIME_SUCCEEDED= 'GET_AVAILABLE_TIME_SUCCEEDED';

export const SELECT_SERVICE = 'SELECT_SERVICE';

export const SELECT_PRODUCT = 'SELECT_PRODUCT';

export const SELECT_TIMESTAMP = 'SELECT_TIMESTAMP';